import React from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from '../../components/LoaderScreen';
import { useEffect, useState, createContext, useRef } from 'react';
import request from '../../../Helpers/API';
import { GetKey } from "../../../Helpers/GetKey";
import { GetMonthNameByNumber } from "../../Finanzas/Helper/GetMonthNameByNumber";
import Swal from "sweetalert2";
import FiltroDashboard from "../../Finanzas/Dashboard/FiltroDashboard";
import { useBox } from "../../Finanzas/Helper/useBox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import SaveIcon from '@mui/icons-material/Save';

export const FacturacionSinUIDSection = ({ data }) => {
    const [facturacion, setFacturacion] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });


    useEffect(() => {
        setFacturacion(data)
    }, [data]);

    return (
        <div className="listado-fiscal-invoicemovimientos-container">
            <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
                <table>
                    <thead>
                        <tr>
                            {/* <th>
                                ID
                            </th> */}
                            <th>
                                Documento
                            </th>
                            <th>
                                <div>Cuenta</div>
                            </th>
                            <th>
                                <div>Fecha</div>
                            </th>
                            <th>
                                <div>Serie Fiscal</div>
                            </th>
                            <th>
                                <div>Folio Fiscal</div>
                            </th>
                            <th>
                                <div>Importe</div>
                            </th>
                            <th>
                                <div>Batch</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {facturacion.map((fac) => (
                            <tr>
                                {/* <td className="ta-center">{fac.idregistro}</td> */}
                                <td className="ta-center">{fac.documento}</td>
                                <td className="ta-center">{fac.cuenta}</td>
                                <td className="ta-center">{new Date(fac.fecha).toLocaleDateString("es-MX", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric"
                                })}</td>
                                <td className="ta-center">{fac.serie_fiscal}</td>
                                <td className="ta-center">{fac.folio_fiscal}</td>
                                <td className="ta-right">{FormatMoney(fac.importe)}</td>
                                <td className="ta-center">{fac.batch}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
